import Api from "../../lib/api";

export const addNewLocationCategory = async (data) => {
    const response = await Api.post(`location-categories`, data);
    return response;
};

export const editLocationCategory = async (data, id) => {
    const response = await Api.put(`location-categories/${id}`, data);
    return response;
};
